/* POPUP */
export const TOGGLE_SEARCH_EMPLOYEE_POPUP = "TOGGLE_SEARCH_EMPLOYEE_POPUP";
export const SET_SELECTED_EMPLOYEE_LIST = "SET_SELECTED_EMPLOYEE_LIST";
export const SET_PREVIEW_EMPLOYEE = "SET_PREVIEW_EMPLOYEE";
export const SET_PREVIEW_EMPLOYEE_SUCCESS = "SET_PREVIEW_EMPLOYEE_SUCCESS";
export const SET_EMPLOYEE_DETAIL = "SET_EMPLOYEE_DETAIL";
export const SET_EMPLOYEE_DETAIL_SUCCESS = "SET_EMPLOYEE_DETAIL_SUCCESS";
export const API_ERROR = "API_ERROR";
export const SET_EMPLOYEE_EXTERNAL_PROFILE = "SET_EMPLOYEE_EXTERNAL_PROFILE";
export const SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS = "SET_EMPLOYEE_EXTERNAL_PROFILE_SUCCESS";
export const SET_EMPLOYEE_ALARM_SETTING = "SET_EMPLOYEE_ALARM_SETTING";
export const SET_EMPLOYEE_ALARM_SETTING_SUCCESS = "SET_EMPLOYEE_ALARM_SETTING_SUCCESS";